module.exports = __webpack_public_path__ + "07827675b5889762ce22778c489b9600.png";